import React from "react";
import MapComponent from "./component/GoogleMap";

interface MapProps {
  locations: { lat: number; lng: number; name: string }[];
  loading: boolean;
  apiKey: string;
  mapRef?: React.RefObject<HTMLDivElement>;
  height?: string | null;
  width?: string | null;
}

const Home: React.FC<MapProps> = (props) => {
  return (
    <div style={{ position: "relative" }}>
      {props?.locations?.length ? (
        <MapComponent
          apiKey={props.apiKey}
          locations={props?.locations || []}
          mapRef={props.mapRef}
          height={props?.height}
          width={props?.width}
          showNumberLabel
        />
      ) : (
        <div
          style={{
            // position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {!props?.loading && props?.locations?.length === 0
            ? "No Data Found"
            : "Loading..."}
        </div>
      )}
    </div>
  );
};

export default Home;
